import { FC } from "react";
import { TableCell, TableHeadCell } from "@rothoblaas/design-system";
import AdminCrudTable from "../../../../components/ui/AdminCrudTable";
import useI18n from "../../../../hooks/useTranslations";
import { ConnectorMaterial } from "../../../../http/deckDesigner/types/connectorMaterials";
import useDeckConnectorMaterialsApi from "../../../../http/deckDesigner/useConnectorMaterials";
import ConnectorMaterialForm from "./ConnectorMaterialForm";

const AdminConnectorMaterials: FC = () => {
  const i18n = useI18n();
  const connectorMaterialsApi = useDeckConnectorMaterialsApi();

  return (
    <AdminCrudTable<ConnectorMaterial>
      filterPrefix="connector_materials"
      useList={connectorMaterialsApi.useDeckConnectorMaterials}
      head={<TableHeadCell align="left">{i18n.translation.common.name}</TableHeadCell>}
      renderRow={(item) => <TableCell>{item.name}</TableCell>}
      onDelete={(item) => connectorMaterialsApi.deleteDeckConnectorMaterial(item.id)}
      deleteTitle={i18n.translation.deckDesignerModule.connectorMaterials.singular}
      canAdd
      renderForm={(item, onClose) => <ConnectorMaterialForm connectorMaterial={item} onClose={onClose} />}
    />
  );
};

export default AdminConnectorMaterials;
